export const HOST_VIEW_PAYMENT = "HOST_VIEW_PAYMENT"
export const HOST_VIEW_PAYMENT_SUCCESSFUL = "HOST_VIEW_PAYMENT_SUCCESSFUL"
export const HOST_VIEW_PAYMENT_FAILED = "HOST_VIEW_PAYMENT_FAILED"